import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import newAssessmentQuery from '../../../graphql/NewAssessmentQuery';
import NewAssessment from './NewAssessment';
import { AssessmentConstants, AppConstants, GRAPHQL_EXCEPTION_CODE } from '../../../shared/Constants';
import { Loading } from '../../../components/Loading';
import { getJobProfilesByAssessmentTmpId } from '../../../services/apps/JobProfileService';
import { fixedLanguage } from '../../../utils/LanguageUtil';
import ArrayUtil from '../../../utils/ArrayUtil';
import { growlErrors } from '../../../utils/NotificationUtil';
import { withGrowl } from '../../../components/GrowlNotifications';
import { withAccount } from '../../../components/AccountContext';

class NewAssessmentContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSaveAssessment = this.handleSaveAssessment.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.loadJobProfileByAssessmentTemplate = this.loadJobProfileByAssessmentTemplate.bind(this);
    this.state = {
      emailsStatus: false,
      jobs: [],
      sendReportsWhenAssessmentIsComplete: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { resQuery, jobProfilesQuery, templateQuery } = nextProps;
    const error = resQuery.error || jobProfilesQuery.error || templateQuery.error;
    if (error) {
      const ex = {
        err: error,
        type: GRAPHQL_EXCEPTION_CODE,
      };
      throw ex;
    }
  }

  async handleSaveAssessment(formValues, resetForm) {
    const {
      currentAccount, history, resQuery, addAssessment, growl,
      match: { params },
    } = this.props;
    const {
      sendReportsWhenAssessmentIsComplete,
      sendingIndividualReport,
      locale,
      subscribed,
      emails,
      autogenerateReports,
      targetJob,
      job_profile_list,
      assessmentTemplate,
      expirationTime,
      printerFriendlyReport,
    } = formValues;
    const { respondentId } = params;
    let decidedExpirationTime = expirationTime;
    if (!expirationTime) {
      const limitDay = new Date();
      limitDay.setDate(limitDay.getDate() + AssessmentConstants.MAX_EXPANDS_TIME);
      decidedExpirationTime = limitDay;
    }

    const jobProfileList = [];
    if (ArrayUtil.isNotEmpty(job_profile_list)) {
      job_profile_list.map(jobprofile => jobProfileList.push(jobprofile.value));
    }

    const formattedExpiration = moment(decidedExpirationTime).format(AppConstants.DEF_LOCAL_DATETIME_FORMAT);
    const AssessmentOptionsInput = {
      notificationEmails: emails,
      reportTypes: autogenerateReports,
      jobProfileIdForSingleJobProfileReports: targetJob ? targetJob.id : '',
      jobProfileIdsForMultipleJobProfileReports: jobProfileList,
      sendReportsWhenAssessmentIsComplete,
      sendingIndividualReport,
      printerFriendlyReport,
      reportPreferLocale: locale,
    };
    if (resQuery.account && resQuery.account.respondent) {
      const viewerLocale = resQuery.account.respondent.locale;
      try {
        await addAssessment({
          variables: {
            input: {
              accountId: currentAccount,
              respondentId,
              locale: viewerLocale,
              expirationTime: formattedExpiration,
              assessmentTemplateId: assessmentTemplate.id,
              subscribed,
              assessmentOptions: AssessmentOptionsInput,
            },
          },
        });
        const resDetailURL = `/accounts/${currentAccount}/respondents/${respondentId}`;
        if (resetForm) {
          resetForm();
        }
        history.push(resDetailURL);
      } catch (graphqlResponse) {
        growlErrors(growl, graphqlResponse);
      }
    }
  }

  async loadJobProfileByAssessmentTemplate(event) {
    const { currentAccount, growl } = this.props;
    try {
      const data = await getJobProfilesByAssessmentTmpId(currentAccount, event.value);
      this.setState({
        jobs: data,
      });
    } catch (err) {
      growlErrors(growl, err);
    }
  }

  handleCancel() {
    const { history, currentAccount, match } = this.props;
    const { respondentId } = match.params;
    const resDetailURL = `/accounts/${currentAccount}/respondents/${respondentId}`;
    history.push(resDetailURL);
  }

  render() {
    const {
      jobs, emailsStatus, sendReportsWhenAssessmentIsComplete,
    } = this.state;
    const {
      resQuery, jobProfilesQuery, templateQuery,
      currentAccount, viewer, translatedTags,
      match,
    } = this.props;
    const loading = resQuery.loading
      || jobProfilesQuery.loading
      || templateQuery.loading;
    if (loading) return (<Loading />);
    const printerFriendlyReport = true;
    const defaultLanguage = fixedLanguage(
      viewer.locale, translatedTags,
    );
    const { respondentId } = match.params;
    const { assessmentTemplates } = templateQuery;
    const { respondent } = resQuery.account;
    const initialValues = {
      respondentId,
      locale: defaultLanguage,
      respondentEmail: respondent.email,
      printerFriendlyReport,
    };
    let assessmentForDropDown = [];
    // eslint-disable-next-line max-len
    assessmentForDropDown = assessmentTemplates && assessmentTemplates.map(assessment => ({ value: assessment.id, text: assessment.title }));
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <NewAssessment
              initialValues={initialValues}
              assessmentTemplates={assessmentForDropDown}
              respondent={respondent}
              onSave={this.handleSaveAssessment}
              onCancel={this.handleCancel}
              activeLocales={translatedTags}
              Change={this.loadJobProfileByAssessmentTemplate}
              listJobProfiles={jobs}
              emailsStatus={emailsStatus}
              viewer={viewer}
              currentAccount={currentAccount}
              sendReportsWhenAssessmentIsComplete={sendReportsWhenAssessmentIsComplete}
            />
          </div>
        </div>
      </div>

    );
  }
}
NewAssessmentContainer.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  resQuery: PropTypes.objectOf(PropTypes.any).isRequired,
  addAssessment: PropTypes.func.isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
  jobProfilesQuery: PropTypes.objectOf(PropTypes.any).isRequired,
  templateQuery: PropTypes.objectOf(PropTypes.any).isRequired,
  viewer: PropTypes.objectOf(PropTypes.any).isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

const NewAssessmentGraphql = newAssessmentQuery(NewAssessmentContainer);

const mapStateToProps = (state) => {
  const { translatedTags } = state.i18n;
  const { user } = state.app;
  return {
    viewer: {
      locale: user.locale,
      ...user,
    },
    translatedTags,
  };
};

export default withGrowl(
  withAccount(
    withRouter(
      connect(mapStateToProps)(NewAssessmentGraphql),
    ),
  ),
);
